import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import NotFoundPanel from 'components/ui/layout/error/NotFoundPanel';

import {changeTitle} from 'modules/ui';

import 'style/routes/no-match.scss';

/** Route to render the Dashboard page including all its content */
class NoMatch extends Component {
    /**
     * Changes the title after the language has been changed.
     */
    componentDidUpdate(prevProps) {
        const {dispatch, intl: {locale}} = this.props;
        const previousLocale = prevProps.intl.locale;

        if (previousLocale && locale && previousLocale !== locale) {
            dispatch(changeTitle(''));
        }
    }

    /**
     * Dispatch the action to change title
     */
    componentDidMount() {
        const {dispatch } = this.props;

        dispatch(changeTitle(''));
    }

    render() {
        const { intl: {formatMessage}} = this.props;
        const dashboardURL = '/';

        return (
            <div className="no-match">
                <NotFoundPanel />
                <Link to={dashboardURL}>
                    {formatMessage({id: 'title.back_to_dashboard'})}
                </Link>
            </div>
        );
    }
}


export default withRouter(injectIntl(connect()(NoMatch)));



// WEBPACK FOOTER //
// ./src/routes/NoMatch.jsx